export const MIN_ALLOWED_DIMENSION = 160;

export enum Unit {
  px = 'px',
}

export const CROP_INITIAL_STATE = {
  x: 0,
  y: 0,
  width: MIN_ALLOWED_DIMENSION,
  height: MIN_ALLOWED_DIMENSION,
  unit: Unit.px,
};
export const MAX_FILE_SIZE = 10000000;

export const ACCEPTED_FORMATS = {
  'image/*': ['.jpeg', '.png', '.bmp'],
};
